var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-card",
    { attrs: { title: "Encontre aqui o seu aplicativo" } },
    [
      _c(
        "template",
        { attrs: { slot: "body" }, slot: "body" },
        [
          this.appList.length > 0
            ? _c(
                "div",
                { staticClass: "filter-name-section" },
                [
                  _c("app-name-filter-field", {
                    attrs: { appList: this.appList }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-installation" },
            [
              _c("h1", [
                _c("b", [_vm._v(_vm._s(_vm.title.installationType.text))])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "sc-radio",
                {
                  staticClass: "filter-installation-item",
                  attrs: { name: "all", "native-value": "All" },
                  on: {
                    input: function() {
                      return _vm.applyFilter()
                    }
                  },
                  model: {
                    value: _vm.installationType,
                    callback: function($$v) {
                      _vm.installationType = $$v
                    },
                    expression: "installationType"
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.title.installationType.all) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-radio",
                {
                  staticClass: "filter-installation-item",
                  attrs: { name: "installed", "native-value": "Installed" },
                  on: {
                    input: function() {
                      return _vm.applyFilter()
                    }
                  },
                  model: {
                    value: _vm.installationType,
                    callback: function($$v) {
                      _vm.installationType = $$v
                    },
                    expression: "installationType"
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.title.installationType.installed) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-radio",
                {
                  staticClass: "filter-installation-item",
                  attrs: {
                    name: "notinstalled",
                    "native-value": "Notinstalled"
                  },
                  on: {
                    input: function() {
                      return _vm.applyFilter()
                    }
                  },
                  model: {
                    value: _vm.installationType,
                    callback: function($$v) {
                      _vm.installationType = $$v
                    },
                    expression: "installationType"
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.title.installationType.notInstalled) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h1", [_c("b", [_vm._v(_vm._s(_vm.title.categoryType))])]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm._l(this.getCategoryList(), function(category) {
            return _c(
              "div",
              { key: category },
              [
                _c(
                  "sc-checkbox",
                  {
                    attrs: { name: category, "native-value": category },
                    on: {
                      input: function() {
                        return _vm.applyFilter()
                      }
                    },
                    model: {
                      value: _vm.appCategory,
                      callback: function($$v) {
                        _vm.appCategory = $$v
                      },
                      expression: "appCategory"
                    }
                  },
                  [_vm._v("\n        " + _vm._s(category) + "\n      ")]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("sc-button", {
            attrs: { theme: "danger", text: "Limpar filtro" },
            on: { click: _vm.clearCategoryFilter }
          }),
          _vm._v(" "),
          _c("hr")
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78c1e240", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c1e240","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/app-filter/NewAppFilter.vue
// module id = null
// module chunks = 